/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Status_PrintingInputs */

const en_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printing`)
};

const es_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimiendo`)
};

const fr_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours d'impression`)
};

const de_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gedruckt`)
};

const ja_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印刷中`)
};

const zh_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印中`)
};

const ar_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري الطباعة`)
};

const id_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencetak`)
};

const it_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In stampa`)
};

const ru_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Печать`)
};

const pt_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Imprimir`)
};

const ko_book_status_printing = /** @type {(inputs: Book_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인쇄 중`)
};

/**
* | output |
* | --- |
* | "Printing" |
*
* @param {Book_Status_PrintingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_status_printing = /** @type {((inputs?: Book_Status_PrintingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Status_PrintingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_status_printing(inputs)
	if (locale === "es") return es_book_status_printing(inputs)
	if (locale === "fr") return fr_book_status_printing(inputs)
	if (locale === "de") return de_book_status_printing(inputs)
	if (locale === "ja") return ja_book_status_printing(inputs)
	if (locale === "zh") return zh_book_status_printing(inputs)
	if (locale === "ar") return ar_book_status_printing(inputs)
	if (locale === "id") return id_book_status_printing(inputs)
	if (locale === "it") return it_book_status_printing(inputs)
	if (locale === "ru") return ru_book_status_printing(inputs)
	if (locale === "pt") return pt_book_status_printing(inputs)
	return ko_book_status_printing(inputs)
});